







































































































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { IRegisterModel } from "src/model";
import { UserService, SmsService } from "src/services";
import patterns from "src/utils/patterns";
import { SmsType } from "src/enums";
import { tools } from "@/utils";

@Component
export default class RegisterForm extends Vue {
  /**
   * 用户服务实例
   * @private
   * @return UserService
   */
  private _userService: UserService;

  /**
   * 是否显示弹框
   * @private
   * @return boolean
   */
  private showModal: boolean = false;

  /**
   * 通讯服务实例
   * @private
   * @return SmsService
   */
  private _smsService: SmsService;

  /**
   *验证码按钮
   * @private
   * @return any
   */
  private validateBtn: any = {
    time: 60,
    text: "获取验证码",
    disabled: true,
  };

  /**
   * 定时器实例
   * @private
   * @return number
   */
  private time: any;

  /**
   * 用户注册模型
   * @private
   * @return IRegisterModel
   */
  private registerModel: IRegisterModel = {
    account: "",
    password: "",
    confirm: "",
    phone: "",
    smsCode: "",
  };

  /**
   * 表单规则
   * @protected
   */
  protected get rules(): any {
    return {
      account: [
        { required: true, message: "请输入用户名！", trigger: "blur" },
        { validator: this.skcuserValidate, trigger: "blur" },
      ],
      password: [
        { required: true, message: "请输入密码！", trigger: "blur" },
        {
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (value.length < 6) {
              callback("密码长度不能小于6位");
            }
            callback();
          },
        },
      ],
      confirm: [
        { required: true, message: "请输入确认密码！", trigger: "blur" },
        {
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (value != this.registerModel.password) {
              callback("两次输入的密码不一致");
            }
            callback();
          },
        },
      ],
      phone: [
        { required: true, message: "请输入手机号！", trigger: "blur" },
        { validator: this.skcuserValidate, trigger: "blur" },
      ],
      smsCode: [{ required: true, message: "请输入短信验证！" }],
    };
  }

  /**
   * 注册表单。
   * @protected
   * @returns any
   */
  public get $registerForm(): any {
    return this.$refs.registerForm as any;
  }

  /**
   * 获取或设置用户实例。
   * @protected
   * @returns UserService
   */
  protected get userService(): UserService {
    if (!this._userService) {
      this._userService = this.$serviceProvier.resolve<UserService>(UserService);
    }

    return this._userService;
  }

  /**
   * 获取或设置通讯服务实例。
   * @protected
   * @returns SmsService
   */
  protected get smsService(): SmsService {
    if (!this._smsService) {
      this._smsService = this.$serviceProvier.resolve<SmsService>(SmsService);
    }

    return this._smsService;
  }

  /**
   * 注册
   * @private
   * @return void
   */
  private async onHandleSubmit(): Promise<void> {
    this.showModal = true;
    return;
    this.$registerForm.validate(async (valid: boolean) => {
      try {
        if (valid) {
          let { content: result } = await this.userService.skcRegister(this.registerModel);
          this.$message.success("注册成功");
          this.$router.push("/login");
        }
      } catch (err) {
        this.$message.error({
          duration: 3,
          content: err || "服务器错误",
        });
      }
    });
  }

  /**
   * 倒计时
   */
  private settime() {
    if (this.validateBtn.time == 0) {
      this.validateBtn.disabled = false;
      this.validateBtn.text = "获取验证码";
      this.validateBtn.time = 60;
      clearInterval(this.time);
    } else {
      this.validateBtn.disabled = true;
      this.validateBtn.text = `重新发送(${this.validateBtn.time})`;
      this.validateBtn.time--;
    }
  }

  /**
   * 获取短信验证码
   * @private
   * @return void
   */
  private async onPhoneChange(): Promise<void> {
    try {
      if (!this.registerModel.phone) {
        this.$message.warning("请输入手机号!");
        this.validateBtn.disabled = true;
        return;
      }

      if (!patterns.mobile.test(this.registerModel.phone)) {
        this.$message.warning("请输入正确手机号!");
        this.validateBtn.disabled = true;
        return;
      }
      this.validateBtn.disabled = false;
      // 用户登入
      let { content: result } = await this.smsService.sendSms({
        smsType: SmsType.registerCode,
        phoneNum: this.registerModel.phone,
      });
      this.time = setInterval(() => {
        console.log(this);
        this.settime();
      }, 1000);
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

  /**
   * 用户名手机号是否
   * @private
   * @return void
   */
  private async skcuserValidate(rule, value, callback): Promise<void> {
    let _this = this;
    let data = {
      type: 0,
      data: "",
      title: "",
    };
    if (rule.field === "account") {
      data.type = 0;
      data.data = this.registerModel.account;
      data.title = "用户名已存在";
    } else {
      tools.validatePhone(null, this.registerModel.phone, function (err) {
        if (err) {
          _this.validateBtn.disabled = true;
          throw err;
        }
      });
      data.type = 1;
      data.data = this.registerModel.phone;
      data.title = "该手机号已存在";
      this.validateBtn.disabled = true;
    }
    if (rule.field !== "account") {
      this.validateBtn.disabled = false;
    }
    try {
      let { content: result } = await this.userService.skcuserValidate({
        data: data.data,
        type: data.type,
      });

      if (!result.data.isSuccess) {
        callback(result.data.msg);
      } else {
        callback();
      }
    } catch (err) {
      this.$message.success(err);
    }
  }

  /**
   * 跳转登入页面
   * @private
   * @return void
   */
  private onLogin(): void {
    this.$router.push({ path: "/login" });
  }
}
